"use strict";

import resource from "vue-resource/src/resource";

export default {
    state: {
        stockOrdersResource: {},
        suppliersResource: {},
        boxTypesResource: {},
        suppliers: [
            {
                id: 0,
                company_name: "Suppliers",
                slug: 'none'
            }
        ],
        boxTypes: null,
        pending: [],
        incoming: [],
        backorders: [],
        completed: {
            current_page: 1,
            last_page: 0
        },
        currentSupplier: {
            id: 0,
            company_name: "Suppliers",
            slug: 'none',
            pivot: { box_id: 0 }
        },
        currentStockOrder: {},
        currentProductSupplierLink: {},
        deliveryLocations: [],
    },

    getters: {
        suppliersResource: ( state ) => {
            return state.suppliersResource;
        },

        stockOrdersResource: ( state ) => {
            return state.stockOrdersResource;
        },

        boxTypesResource: ( state ) => {
            return state.boxTypesResource;
        },

        pendingOrders: ( state ) => {
            return state.pending
        },

        incomingOrders: ( state ) => {
            return state.incoming
        },

        backorderOrders: ( state ) => {
            return state.backorders;
        },

        completedOrders: ( state ) => {
            return state.completed;
        },

        suppliers: ( state ) => {
            return state.suppliers;
        },

        boxTypes: ( state ) => {
            return state.boxTypes;
        },

        currentSupplier: ( state ) => {
            return state.currentSupplier;
        },

        currentStockOrder: ( state ) => {
            return state.currentStockOrder;
        },

        currentProductSupplierLink: ( state ) => {
            return state.currentProductSupplierLink;
        },
        
        deliveryLocations: (state) => {
            return state.deliveryLocations;
        }
    },

    mutations: {
        currentSupplier: ( state, supplier ) => {
            state.currentSupplier = supplier;
        },

        orders: ( state, ordersData ) => {
            state[ ordersData.orderType ] = ordersData.orders;
        },

        completed: ( state, completed ) => {
            state.completed = completed;
        },

        completedData: ( state, completed ) => {
            state.completed.data = completed;
            state.completed.total = completed.length;
            state.completed.last_page = Math.ceil( completed.length / state.completed.per_page );
        },

        incoming: ( state, incoming ) => {
            state.incoming = incoming;
        },

        pending: ( state, pending ) => {
            state.pending = pending;
        },

        suppliers: ( state, suppliersData ) => {
            state.suppliers = [
                {
                    id: 0,
                    company_name: "All Suppliers"
                }
            ];

            state.suppliers = state.suppliers.concat( suppliersData );
        },

        boxTypes: ( state, boxTypes ) => {
            state.boxTypes = boxTypes;
        },

        moveOrder: ( state, data ) => {
            _.remove( state[ data.from ], { 'id': data.order.id } );
            state[ data.to ].push( data.order );
        },

        newPendingOrder: ( state, order ) => {
            state.pending.unshift( order );
        },

        currentStockOrder: ( state, order ) => {
            state.currentStockOrder = order
        },

        currentProductSupplierLink: ( state, link ) => {
            state.currentProductSupplierLink = link;
        },
        
        boxTypesResource: (state, resource) => {
            state.boxTypesResource = resource;
        },
        
        stockOrdersResource: (state, resource) => {
            state.stockOrdersResource = resource;
        },
        
        suppliersResource: (state, resource) => {
            state.suppliersResource = resource;
        },
        
        deliveryLocations: (state, locations) => {
            state.deliveryLocations = locations;
        }
    },

    actions: {
        currentSupplier: ( { commit, state, getters }, supplierSlug ) => {
            return new Promise( ( resolve, reject ) => {
                let supplier = _.find( state.suppliers, { 'slug': supplierSlug } );
                if ( supplier ) {
                    commit( 'currentSupplier', supplier );
                    resolve( supplier )
                } else {
                    getters.suppliersResource.get( { 'supplierSlug': supplierSlug } ).then(
                        ( supplier ) => {
                            commit( 'currentSupplier', supplier.body );
                            resolve( supplier.body );
                        },
                        ( error ) => {
                            reject( new Error( 'Supplier not found' ) );
                        }
                    );
                }
            } );
        },

        fetchAllOrderTypes: ( { commit, state } ) => {
            return new Promise( ( resolve, reject ) => {
                    state.stockOrdersResource.allTypes().then(
                        ( orders ) => {
                            let orderTypes = orders.body;
                            _.each( orderTypes, ( orders, type ) => {
                                commit( 'orders', {
                                    'orderType': type,
                                    'orders': orders
                                } );
                            } );
                            resolve()
                        },
                        ( error ) => {
                            reject( error );
                        }
                    );
                }
            );
        },

        fetchOrders: ( { commit, state }, fetchData ) => {
            return new Promise( ( resolve, reject ) => {
                state.stockOrdersResource.orderType( { orderType: fetchData.orderType, page: fetchData.page } ).then(
                    ( orders ) => {
                        commit( fetchData.orderType,
                            orders.body
                        );
                        resolve();
                    }, ( error ) => {
                        reject( new Error( 'Failed to fetch ' + fetchData.orderType + ' orders' ) )
                    }
                );
            } );
        },

        fetchBoxTypes: ( { commit, state } ) => {
            return new Promise( ( resolve, reject ) => {
                state.boxTypesResource.get().then(
                    ( boxTypes ) => {
                        commit( 'boxTypes', boxTypes.body );
                        resolve()
                    },
                    ( error ) => {
                        reject( new Error( 'Problem fetching box types' ) );
                    }
                )
            } );
        },

        deleteStockOrder: ( { state }, orderId ) => {
            let removeFunc = function ( order ) {
                return order.id !== orderId;
            };

            if ( _.find( state.pending, { 'id': orderId } ) !== undefined ) {
                state.pending = _.remove( state.pending, removeFunc );
            }

            if ( _.find( state.backorders, { 'id': orderId } ) !== undefined ) {
                state.backorders = _.remove( state.backorders, removeFunc );
            }
        },

        reorderStockOrders: ( { state }, data ) => {
            _.defaults( data, { field: 'created_at', order: 'desc' } );
            state[ data.orderType ] = _.orderBy( state[ data.orderType ], [ data.field ], [ data.order ] );
        },
    
        createStockOrder: ( { state }, orderData ) => {
            return new Promise( ( resolve, reject ) => {
                state.stockOrdersResource.save( orderData ).then(
                    ( order ) => {
                        resolve( order.body );
                    },
                
                    ( error ) => {
                        reject( error );
                    }
                )
            } );
        },
    
        orderReturned: ( { state, getters, commit, dispatch }, data ) => {

        },

        updateStockLink: ( { state, getters }, linkData ) => {
            return new Promise( ( resolve, reject ) => {
                getters.suppliersResource.updateLink(
                    {
                        suppliersSlug: linkData.suppliersSlug,
                        productSlug: linkData.productSlug
                    },
                    linkData.link
                ).then(
                    ( response ) => {
                        resolve( response.data );
                    }
                ).catch(
                    () => {
                        reject( 'Error updating supplier link' );
                    }
                );
            } );
        },
    
        updateStockOrderItem: ( { state }, itemData ) => {
            console.log( itemData );
            return new Promise( ( resolve, reject ) => {
                state.stockOrdersResource.updateStockOrderItem(
                    {
                        stockOrderId: itemData.stockOrderId,
                        itemId: itemData.itemId
                    },
                    itemData
                )
                    .then(
                        ( order ) => {
                            resolve( order.body );
                        },
                        ( error ) => {
                            reject( error );
                        }
                    );
            } );
        
        },
        
        unlinkProductSupplier: ( { state, getters }, linkData ) => {
            return new Promise( ( resolve, reject ) => {
                getters.suppliersResource.removeLink(
                    {
                        suppliersSlug: linkData.suppliersSlug,
                        productSlug: linkData.productSlug
                    }
                ).then(
                    ( response ) => {
                        resolve( response.data );
                    }
                ).catch(
                    () => {
                        reject( 'Error removing supplier link' );
                    }
                );
            } );
        },

        addToPending( { state, commit }, order ) {
            _.$update( state.pending, { 'id': order.id }, order );
            commit( 'pending', _.orderBy( state.pending, [ 'created_at' ], [ 'desc' ] ) );
        },

        addToIncoming( { state, commit }, order ) {
            _.$update( state.incoming, { 'id': order.id }, order );
            commit( 'incoming', _.orderBy( state.incoming, [ 'placed_at' ], [ 'desc' ] ) );
        },

        addToCompleted( { state, commit }, order ) {
            _.$update( state.completed.data, { 'id': order.id }, order );
            commit( 'completedData', _.orderBy( state.completed.data, [ 'received_at' ], [ 'desc' ] ) );
        },

        removeFromIncoming( { state, commit }, order ) {
            commit( 'incoming', _.filter( state.incoming, function ( incomingOrder ) {
                return incomingOrder.id !== order.id
            } ) );
        },

        removeFromPending( { state, commit }, order ) {
            commit( 'pending', _.filter( state.pending, function ( pendingOrder ) {
                return pendingOrder.id !== order.id
            } ) );
        },

        removeFromCompleted( { state, commit }, order ) {
            commit( 'completedData', _.filter( state.completed.data, function ( completedOrder ) {
                return completedOrder.id !== order.id
            } ) );
        },

        moveStockOrderItem( { getters, commit, dispatch }, data ) {
            return new Promise( ( resolve, reject ) => {
                getters.stockOrdersResource.moveStockOrderItem(
                    {
                        stockOrderId: data.stockOrderId,
                        itemId: data.itemId
                    },
                    {
                        suppliersId: data.suppliersId
                    }
                ).then(
                    ( response ) => {
                        dispatch( 'addToPending', response.data );
                        resolve( response.data );
                    },
                    ( error ) => {
                        reject( 'Problem moving item' );
                    }
                );
            } );
        },

        /**
         *
         * @param getters
         * @param commit
         * @param dispatch
         * @param {object} data
         */
        setupEditSupplierLink( { getters, commit, dispatch }, data ) {

            let doFilter = ( productSlug ) => {
                console.log( 'product slug in filter', productSlug );
                console.log( 'current supplier products', getters.currentSupplier.products );
                return _.find( getters.currentSupplier.products, { slug: productSlug } )
            };

            return new Promise( ( resolve, reject ) => {
                if ( typeof data.supplierSlug !== "undefined" ) {
                    dispatch( 'currentSupplier', { supplierSlug: data.supplierSlug } )
                        .then(
                            ( supplier ) => {
                                let product = doFilter( data.productSlug );
                                commit(
                                    'currentProductSupplierLink',
                                    product
                                );
                                resolve( product );
                            },
                            ( error ) => {
                                console.log( 'error' );
                                reject( 'Problem getting link information' );
                            }
                        );
                } else {
                    let product = doFilter( data.productSlug );
                    console.log( 'doFilter response', product );
                    commit(
                        'currentProductSupplierLink',
                        product
                    );
                    resolve( product );
                }


            } );
        },
        sortStock( { state, commit }, sortData ) {
            commit( sortData.orderType, _.orderBy( state[ sortData.orderType ], sortData.column, sortData.order ) );
        },

        replaceSupplier: ( { state, commit }, supplier ) => {
            _.$update( state.suppliers, { 'id': supplier.id }, supplier );
            let holder = state.suppliers[0]; // get the place holder
            _.remove(state.suppliers, { 'id': 0 });
            _.sortBy( state.suppliers, [ 'company_name' ] );
            state.suppliers.unshift(holder); // put the holder back in the top of the array
            commit('currentSupplier', supplier);
        },

        deleteSupplier: ( {state, commit} , supplierSlug ) => {
            console.log(state);
            console.log('state before remove', state.suppliers);
            _.remove( state.suppliers, { 'slug': supplierSlug } );
            console.log('state after remove', state.suppliers);
            commit('currentSupplier', state.suppliers[0]);
            console.log('currentSupplier', state.currentSupplier);
        },
    }
};
